import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import AppsGrid from '../shared/AppsGrid';

interface AppsTabProps {
  channelId?: string;
  channelName?: string;
  isChannelArchived?: boolean;
  pageSize?: number;
  subCategory?: string; // Optional sub_category filter (e.g., "Datasource")
  filterIsActive?: boolean; // Whether to filter by is_active: true only
}

const AppsTab: React.FC<AppsTabProps> = ({ 
  channelId: propChannelId, 
  channelName, 
  isChannelArchived = false, 
  pageSize: propPageSize,
  subCategory,
  filterIsActive
}) => {
  const { channelId: routeChannelId } = useParams<{ channelId: string }>();
  const channelId = propChannelId || routeChannelId; // Use prop if provided, otherwise use route param
  const pageSize = propPageSize || 24;

  return (
    <Box>
      <AppsGrid
        channelId={channelId}
        channelName={channelName}
        isChannelArchived={isChannelArchived}
        pageSize={pageSize}
        showSearch={true}
        showCategoryFilter={true}
        selectionMode={false}
        subCategory={subCategory}
        filterIsActive={filterIsActive}
      />
    </Box>
  );
};

export default AppsTab;